<template>
    <div v-if="hasAuth('Draft')">
        <list-container :header="translate('draftList.jobDrafts')" v-show="!$route.params.id">
            <template v-slot:commands>
                <button class="btn btn-primary float-right" @click="$router.push({ name:'DraftDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('draftList.newJobDraft')}}
                </button>
            </template>
            <list v-if="!$route.params.id" :columns="columns" url="/draft/get" modelName="Draft" predicate="RelatedJob == null && Title != null" orderBy="CreateDate desc">

            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'

export default {
    data(){
        return {
            columns : [
                {
                    Key: "Title",
                    Title: this.translate('draftList.jobName'),
                    SortField: "Title"
                },
                {
                    Key: "Owner",
                    Title:this.translate('draftList.owner'),
                    Content(i){
                        return `
                            <div class="person">
                                ${String.cleanHtml(i.Owner?.FirstName)} ${String.cleanHtml(i.Owner?.LastName)}
                            </div>
                            `;
                    }
                },
                {
                    Key: "DocumentNumber",
                    Title:this.translate('draftList.docNo'),
                    SortField: "DocumentNumber"
                },
                // {
                //     Key: "DocumentType",
                //     Title:"Türü",
                //     SortField: "DocumentType",
                //     Content(i) {
                //         return Vue.filter('documentType')(i.DocumentType);
                //     }
                // },
                {
                    Key: "ReferenceJob",
                    Title:this.translate('draftList.revision'),
                    //SortField: "ReferenceJob.TrackingNo.Number",
                    Content(i) {
                        if(i.TrackingNo)
                            return Vue.filter('trackingNo')(i.TrackingNo);
                    }
                },
                {
                    Key: "CreateDate",
                    Title:this.translate('draftList.create'),
                    SortField: "CreateDate",
                    Class: "text-center",
                    Content(i) {
                        return Vue.filter('datetime')(i.CreateDate);
                    }
                }
            ]
        }
    },
    components: {
        list,
        listContainer
    },
    methods: {
        // select(i){
        //     console.log('Kayıt seçildi: ', i);
        //     this.$router.push('draft/' + i.Id);
        // }
    }
}
</script>